// **********************************************************
// Timeline Module
// **********************************************************

const skipNextEmptySlide = (slider) => {
  let currentIndex = slider.realIndex;
  while (currentIndex > 0 && slider.slides[currentIndex].classList.contains('empty-slide')) {
    currentIndex--;
  }
  slider.slideTo(currentIndex);
};

const skipPrevEmptySlide = (slider) => {
  let currentIndex = slider.realIndex;
  const totalSlides = slider.slides.length;
  while (currentIndex < totalSlides - 1 && slider.slides[currentIndex].classList.contains('empty-slide')) {
    currentIndex++;
  }
  slider.slideTo(currentIndex);
};

const timelineThumb = document.querySelectorAll('[data-slider="timeline-thumb-slider"]');
const timelineMain = document.querySelectorAll('[data-slider="timeline-main-slider"]');

// 1.1 - Timeline Module Thumb Slider
const timelineThumbOptions = {
  slidesPerView: 4,
  spaceBetween: 20,
  watchOverflow: true,
  speed: 600,
  freeMode: {
    enabled: true,
  },
  breakpoints: {
    767: {
      slidesPerView: 8.5,
      spaceBetween: 20,
    },
    1023: {
      slidesPerView: 15,
      spaceBetween: 10,
    },
  },
};

timelineThumb.forEach((el) => new Swiper(el, timelineThumbOptions));

// 1.2 - Timeline Module Main Slider
const timelineMainOptions = {
  slidesPerView: 1,
  spaceBetween: 80,
  watchOverflow: true,
  autoHeight: true,
  speed: 400,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  thumbs: {
    swiper: false,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    1023: {
      autoHeight: false,
    },
  },
  on: {
    slidePrevTransitionStart: (swiper) => {
      skipNextEmptySlide(swiper);
    },
    slideNextTransitionStart: (swiper) => {
      skipPrevEmptySlide(swiper);
    },
  },
};

timelineMain.forEach((el, i) => {
  const parentEle = el.querySelectorAll('.timeline-module__main-slide-content');

  timelineMainOptions.thumbs.swiper = timelineThumb[i].swiper;
  const mainSlider = new Swiper(el, timelineMainOptions);

  parentEle.forEach((element) => {
    const arrowRight = element.querySelector('.swiper-button-next');
    const arrowLeft = element.querySelector('.swiper-button-prev');

    arrowLeft?.addEventListener('click', () => {
      skipNextEmptySlide(mainSlider);
    });

    arrowRight?.addEventListener('click', () => {
      skipPrevEmptySlide(mainSlider);
    });
  });
});

const scrollToSlide = (element, scrollBehavior) => {
  const elementRect = element.getBoundingClientRect();
  const scrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
  const topOffset = elementRect.top + scrollTop - 140;
  window.scrollTo({
    top: topOffset,
    behavior: scrollBehavior,
  });
};

attachEvent('.timeline-module .slider-nav__arrow', 'click', (ev) => {
  if (windowWidth() < breakpointMd) {
    setTimeout(() => {
      const parentEle = ev.target.closest('.timeline-module');
      const content = parentEle.querySelector('.swiper-slide-active .timeline-module__main-slide-content');
      scrollToSlide(content, 'smooth');
    }, 300);
  }
});
